module.exports = __webpack_public_path__ + "img/37.e070db14.png";